import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { showWebcamModal } from '../../state/actions/stepActions'
import {
  updateFilePreview,
  uploadFile,
  updateComponent
} from '../../state/actions/componentsActions'
import Spinner from '../spinner'
import { connect } from 'react-redux'
import MobileDetect from 'mobile-detect'
import { fileTypes, camelize, getValidationsResult, cleanupString, resizeImage, MAX_IMAGE_UPLOAD_SIZE } from '../../utils'

import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'

const md = new MobileDetect(window.navigator.userAgent)

class File extends Component {
  constructor(props) {
    super(props)

    this.state = {
      focused: false
    }
  }

  componentWillMount() {
    const { component, dispatch } = this.props

    if (!component.value) {
      dispatch(updateFilePreview(component))
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.component) {
      nextProps.component.styleObj = {}
      if (!!nextProps.component.value) {
        nextProps.component.styleObj = {
          backgroundImage: `url(${nextProps.component.value})`
        }
      }
    }
  }

  onUploaderClick(e) {
    if (!md.mobile()) {
      const { dispatch, component } = this.props
      if (e.currentTarget.id.indexOf('--out') < 0) {
        e.preventDefault()
        dispatch(showWebcamModal(component))
      }
    }
  }

  onFileUpload(e) {
    e.preventDefault()
    const { component, dispatch } = this.props
    const reader = new FileReader()
    const file = e.target.files[0]
    if (!!file) {
      if (fileTypes.some(f => f.toUpperCase() === file.type.toUpperCase())) {
        if (file.type === 'application/pdf') {
          reader.addEventListener("load", function () {
            dispatch(uploadFile({ ...component, value:reader.result }, file))
          }, false);
          reader.readAsDataURL(file)
        }
        else {
          reader.onloadend = () => {
            resizeImage(reader.result, MAX_IMAGE_UPLOAD_SIZE).then(dataUri => {
              dispatch(uploadFile({ ...component, value: dataUri }, file))
            })
          }
          reader.readAsDataURL(file)
          e.target.value = ''
        }
      }
      else {
        return dispatch(
          updateComponent(
            component.id,
            {
              value: '',
              errorMessage: "InValid File Format",
              isLoading: false
            },
            { avoidValidation: true }
          )
        )

      }
    }
  }
  getProperErrorMessage() {
    const { component } = this.props

    if (!!component.validations.overrides) {
      const validationResult = getValidationsResult({
        component,
        type: 'overrides'
      })
      if (!validationResult.result) {
        return validationResult.errorMessage
      }
    }
    return component.errorMessage //&& component.errorMessage[0]
  }
  focus() {
    this.setState({ focused: true })
  }

  blur() {
    this.setState({ focused: false })
  }

  dragOver(e) {
    if (e.target.name !== 'SELFIE-SELFIE_UPLOAD') {
      this.focus()
    }
  }

  drop(e) {
    if (e.target.name === 'SELFIE-SELFIE_UPLOAD') {
      e.preventDefault()
    }
    this.blur()
  }

  render() {
    const { component, components } = this.props

    const documentTypeComponent = components['DOCUMENTO-TIPO_DOCUMENTO']

    const modifiers = [
      !!md.mobile() && this.props.styles['uploader--mobile'],
      component.name.indexOf('DOCF') > -1 &&
      !!documentTypeComponent &&
      documentTypeComponent.value === 'Carta d\'identita' &&
      this.props.styles['uploader--idcard-front'],
      component.name.indexOf('DOCR') > -1 &&
      !!documentTypeComponent &&
      documentTypeComponent.value === 'Carta d\'identita' &&
      this.props.styles['uploader--idcard-back'],
      component.name.indexOf('DOCF') > -1 &&
      !!documentTypeComponent &&
      documentTypeComponent.value === 'Patente di guida' &&
      this.props.styles['uploader--license-front'],
      component.name.indexOf('DOCR') > -1 &&
      !!documentTypeComponent &&
      documentTypeComponent.value === 'Patente di guida' &&
      this.props.styles['uploader--license-back'],
      component.name.indexOf('DOCF') > -1 &&
      !!documentTypeComponent &&
      documentTypeComponent.value === 'Passaporto' &&
      this.props.styles['uploader--passport-front'],
      component.name.indexOf('DOCR') > -1 &&
      !!documentTypeComponent &&
      documentTypeComponent.value === 'Passaporto' &&
      this.props.styles['uploader--passport-back'],
      component.name.indexOf('SELFIE') > -1 &&
      this.props.styles['uploader--selfie'],
      component.name.indexOf('IDENT_WEBCAM') >= 0 &&
      this.props.styles['uploader--identwebcam'],
      !!component.value && this.props.styles['uploader--filled'],
      !component.value &&
      component.status.indexOf('error') > -1 &&
      this.props.styles[
      !!md.mobile() || component.name.indexOf('SELFIE') > -1
        ? 'uploader--error-mobile'
        : 'uploader--error'
      ],
      !!component.isLoading && this.props.styles['uploader--loading'],
      !!this.state.focused &&
      this.props.styles[
      !!md.mobile() || component.name.indexOf('SELFIE') > -1
        ? 'uploader--focus-mobile'
        : 'uploader--focus'
      ]
    ].filter(e => !!e)

    return (      
      <div
        {...css(
          this.props.styles.component,
          component.fullWidth && this.props.styles.singleField,
          this.props.styles.uploader,
          ...modifiers
        )}
        style={component.styleObj}
      >
        {!!this.props.component.isLoading ? <Spinner type="local" /> : ''}
        <input
          type="file"
          id={`${component.id}--out`}
          {...css(
            this.props.styles['input-file'],
            this.props.styles['input-file--out']
          )}
          // value={component.value}
          onChange={event => this.onFileUpload(event)}
          onClick={this.onUploaderClick.bind(this)}
          name={component.id}
        />{' '}
        <input
          type="file"
          id={component.id}
          {...css(this.props.styles['input-file'])}
          // value={component.value}
          onFocus={this.focus.bind(this)}
          onDragOver={this.dragOver.bind(this)}
          onDragEnd={this.blur.bind(this)}
          onDragLeave={this.blur.bind(this)}
          onDrop={this.drop.bind(this)}
          onBlur={this.blur.bind(this)}
          onChange={event => this.onFileUpload(event)}
          onClick={this.onUploaderClick.bind(this)}
          name={component.id}
          //accept="image/*"
          accept=".pdf,.jpeg,.gif,.png,.pjpeg,.x-png"
          {...(component.name.indexOf('SELFIE') > -1
            ? {
              id: 'capture',
              capture: 'camera'
            }
            : {})}
        />
        <label
          htmlFor={component.id}
          {...css(
            this.props.styles['input-file__label'],
            component.name.indexOf('SELFIE') > -1 &&
            this.props.styles['input-file__label--selfie'],
            !!component.value && this.props.styles['input-file__label--filled']
          )}
        >
          {' '}
          {component.cleanName}{' '}
        </label>
        {/* {component.id==='DOCUMENTO_2-DOCF_UPLOAD' &&(components["DOCUMENTO_2-BOLLETTA"].value==='selected' ||
        components["DOCUMENTO_2-BUSTA_PAGA"].value==='selected'||
        components["DOCUMENTO_2-ESTRATTO_CONTO"].value==='selected')
        ?<p>Il documento non deve essere più vecchio di 3 mesi ed intestato al richiedente.</p>:""} */}
        <br />
        <small {...css(this.props.styles['error-msg'])}>
          {camelize(this.getProperErrorMessage(), true, true)}
        </small>
      </div>
    )
  }
}

File.propTypes = {
  widget: PropTypes.object.isRequired,
  component: PropTypes.object.isRequired,
  components: PropTypes.object.isRequired,
  styles: PropTypes.object.isRequired
}

const mapStateToProps = (state/*, ownProps*/) => {
  const { step } = state
  return { step }
  //return {}
}

export default connect(mapStateToProps)(withStyles(Styles)(File))



// WEBPACK FOOTER //
// ./components/file/index.js